import React from "react";

export const STAGES = [
  { key: "w1", label: "1 Week", hint: "0–7 din" },
  { key: "w2", label: "2 Week", hint: "8–14 din" },
  { key: "w3", label: "3 Week", hint: "15–21 din" },
  { key: "w4", label: "4 Week", hint: "22–30 din" },
  { key: "m1", label: "1 Month+", hint: "30 din se zyada", danger: true },
];

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

function Card({ label, hint, count, amount, active, danger, onClick, testid }) {
  const base = danger
    ? (active ? "border-red-500 bg-red-500/25 ring-2 ring-red-500" : "border-red-500/50 bg-red-500/10 hover:bg-red-500/15")
    : (active ? "border-orange-500 bg-orange-500/10 ring-2 ring-orange-500" : "border-slate-700 bg-slate-800/40 hover:bg-slate-800/70");
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={`text-left rounded-sm border p-3 transition-colors ${base}`}>
      <div className={`text-xs font-bold tracking-wider ${danger ? "text-red-300" : "text-slate-300"}`}>{label}</div>
      <div className="text-[11px] text-slate-400">{hint}</div>
      <div className={`mt-2 text-lg font-mono-num font-bold ${danger ? "text-red-400" : "text-slate-100"}`}>{inr(amount)}</div>
      <div className="text-[11px] text-slate-400">{count} customers</div>
    </button>
  );
}

export function DueStageCards({ summary, total, active, onPick }) {
  const all = Object.values(summary || {}).reduce((a, s) => a + (s.amount || 0), 0);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2" data-testid="dues-stage-cards">
      <Card label="Sab" hint="saare due" count={total} amount={all} active={active === "all"}
        onClick={() => onPick("all")} testid="dues-stage-all" />
      {STAGES.map((s) => (
        <Card key={s.key} {...s} count={summary?.[s.key]?.count || 0} amount={summary?.[s.key]?.amount}
          active={active === s.key} onClick={() => onPick(s.key)} testid={`dues-stage-${s.key}`} />
      ))}
    </div>
  );
}
